import {
  Notification,
} from "../features/notifications/interfaces/notifications.interface";

export const formatNotificationData = (
  notificationsData: any[],
): Notification[] => {
  return notificationsData.map((n: any) => {
    const created = n.createdAt ? new Date(n.createdAt) : new Date();
    const type = n.type ?? n._type ?? "SYSTEM";
    const formatTime = (date: Date) =>
      date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

    const getDayLabel = (date: Date) => {
      const d = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      d.setHours(0, 0, 0, 0);
      if (d.getTime() === today.getTime()) return "Today";
      if (d.getTime() === yesterday.getTime()) return "Yesterday";
      return d.toLocaleDateString();
    };

    // Parse meta if it's a string
    let meta = n.meta ?? n.metadata;
    if (typeof meta === "string") {
      try {
        meta = JSON.parse(meta);
      } catch (error) {
        meta = null;
      }
    }

    // For product notifications, map message to text/additionalText structure
    let text = n.text || n.title;
    let additionalText = n.additionalText || meta?.additionalText;
    let subText = n.subText || meta?.subText;

    // Product / listing notifications — keep listing copy separate from seller onboarding
    if (type === "product" && n.message) {
      const message = n.message;
      const lower = message.toLowerCase();

      if (
        message.includes("Your listing") &&
        message.includes("is now available")
      ) {
        const titleMatch = message.match(/Your listing "([^"]+)"/);
        const listingTitle =
          titleMatch?.[1] || meta?.productTitle || n.meta?.productTitle;
        text = "Your listing has been posted,";
        additionalText = listingTitle
          ? `"${listingTitle}" is now live on the marketplace.`
          : "It is now available for buyers.";
      } else if (
        lower.includes("now a seller") ||
        (lower.includes("profile") && lower.includes("updated") && !lower.includes("listing"))
      ) {
        text = n.text || n.title || message;
        additionalText = n.additionalText || meta?.additionalText;
        subText = n.subText || meta?.subText;
      } else {
        text = n.title || message;
        additionalText = meta?.additionalText;
        subText = meta?.subText;
      }
    }

    const title =
      n.title ??
      meta?.senderName ??
      meta?.sellerName ??
      (type === "message" ? "Someone" : "Notification");
    const body = n.body ?? n.message ?? "";

    return {
      ...n,
      type,
      title,
      body,
      meta,
      text,
      additionalText,
      subText,
      day: getDayLabel(created),
      time: n.time || formatTime(created),
      actor: n.actor || undefined,
    };
  });
};
